export const ShareIOSIcon = () => (
  <svg width="17" height="23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className="primary-path"
      d="M8.82.836A.476.476 0 008.1.84L4.907 4.571a1.006 1.006 0 00.105 1.413.991.991 0 001.404-.106l1.125-1.315v9.546c0 .534.429.967.958.967.53 0 .958-.433.958-.967V4.594l1.133 1.293a.992.992 0 001.405.089c.412-.366.452-.999.089-1.414L8.82.836z"
      fill="#27292D"
    />
    <path
      className="secondary-path"
      d="M.833 9.195c0-.998.806-1.792 1.783-1.792h2.05c.53 0 .959.433.959.967s-.43.967-.958.967H2.75v11.4h11.5v-11.4h-1.917a.963.963 0 01-.958-.967c0-.534.43-.967.958-.967h2.051c.977 0 1.783.794 1.783 1.792V20.88c0 .997-.806 1.792-1.783 1.792H2.616A1.787 1.787 0 01.833 20.88V9.195z"
      fill="#27292D"
    />
  </svg>
);
